"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = require("@trs/config");
var _utils = require("@trs/utils");
var _LegendItem2 = _interopRequireDefault(require("./LegendItem.style"));
var _currency = _interopRequireDefault(require("../currency"));
var _LegendItemBoxColor = _interopRequireDefault(require("./LegendItemBoxColor"));
var _input = require("../input");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LegendItem = /*#__PURE__*/function (_Component) {
  function LegendItem(props) {
    var _this;
    _classCallCheck(this, LegendItem);
    _this = _callSuper(this, LegendItem, [props]);
    _defineProperty(_this, "onTouch", function () {
      if (_this.state.touchStarted) {
        _this.props.onClick();
        _this.stopTap();
      }
    });
    _defineProperty(_this, "startTap", function () {
      _this.setState({
        touchStarted: true
      }, _this.props.onMouseOver);
    });
    _defineProperty(_this, "stopTap", function () {
      _this.setState({
        touchStarted: false
      }, _this.props.onMouseOut);
    });
    _this.state = {
      touchStarted: false
    };
    return _this;
  }
  _inherits(LegendItem, _Component);
  return _createClass(LegendItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        boxColor = _this$props.boxColor,
        label = _this$props.label,
        value = _this$props.value,
        percent = _this$props.percent,
        currency = _this$props.currency,
        active = _this$props.active,
        highlightRow = _this$props.highlightRow,
        onMouseOver = _this$props.onMouseOver,
        onMouseOut = _this$props.onMouseOut,
        onClick = _this$props.onClick,
        isAmount = _this$props.isAmount,
        id = _this$props.id,
        className = _this$props.className,
        description = _this$props.description,
        textValue = _this$props.textValue;
      var textValueDisplay = (0, _utils.safeTrim)(textValue);
      return /*#__PURE__*/_react["default"].createElement(_LegendItem2["default"], {
        className: className,
        highlightRow: highlightRow,
        onMouseOver: onMouseOver,
        onFocus: onMouseOver,
        onBlur: onMouseOut,
        onMouseOut: onMouseOut,
        onTouchStart: this.startTap,
        onTouchCancel: this.stopTap,
        onTouchMove: this.stopTap,
        onTouchEnd: this.onTouch,
        active: active,
        onClick: onClick,
        id: id
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "legend-label"
      }, boxColor && /*#__PURE__*/_react["default"].createElement(_LegendItemBoxColor["default"], {
        isNegative: value < 0,
        boxColor: boxColor,
        active: active
      }), label, percent !== null && " (".concat(percent, "%)")), /*#__PURE__*/_react["default"].createElement("span", {
        className: "legend-value"
      }, isAmount && /*#__PURE__*/_react["default"].createElement(_currency["default"], {
        currency: currency,
        decimals: _config.MAX_DECIMALS,
        shouldParseFloat: true
      }, value)), description && /*#__PURE__*/_react["default"].createElement(_input.RichTextarea, {
        className: "legend-description",
        value: description,
        readOnly: true,
        ariaDescribedBy: id
      }), textValueDisplay && /*#__PURE__*/_react["default"].createElement(_input.RichTextarea, {
        className: "text-element",
        value: textValueDisplay,
        readOnly: true,
        ariaDescribedBy: id
      }));
    }
  }]);
}(_react.Component);
LegendItem.defaultProps = {
  className: 'legend-item',
  percent: null,
  active: false,
  highlightRow: false,
  onMouseOver: function onMouseOver() {},
  onMouseOut: function onMouseOut() {},
  boxColor: null,
  onClick: function onClick() {},
  id: null,
  isAmount: true,
  description: '',
  textValue: ''
};
LegendItem.propTypes = {
  /** legend item class name */
  className: _propTypes["default"].string,
  /** color of the box before the legend item */
  boxColor: _propTypes["default"].string,
  /** item label */
  label: _propTypes["default"].string.isRequired,
  /** item value */
  value: _propTypes["default"].number.isRequired,
  /** item description */
  description: _propTypes["default"].string,
  /** if the item has an amount or is text only */
  isAmount: _propTypes["default"].bool,
  /** item percentage value */
  percent: _propTypes["default"].number,
  /** item currency value */
  currency: _propTypes["default"].string.isRequired,
  /** flag to indicate if item is hovered */
  active: _propTypes["default"].bool,
  /** if active, the row will be highlighted on mouseOver */
  highlightRow: _propTypes["default"].bool,
  /** updater for when mouse is over item */
  onMouseOver: _propTypes["default"].func,
  /** updater for when mouse leaves the hovered item */
  onMouseOut: _propTypes["default"].func,
  /** action on item click */
  onClick: _propTypes["default"].func,
  /** id of the element */
  id: _propTypes["default"].string,
  textValue: _propTypes["default"].string
};
var _default = exports["default"] = LegendItem;